var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQualifyBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0L18.7082 3.58732L23.8168 2.86475L24.7082 7.94658L29.2658 10.3647L27 15L29.2658 19.6353L24.7082 22.0534L23.8168 27.1353L18.7082 26.4127L15 30L11.2918 26.4127L6.18322 27.1353L5.2918 22.0534L0.734152 19.6353L3 15L0.734152 10.3647L5.2918 7.94658L6.18322 2.86475L11.2918 3.58732L15 0Z",
    fill: "#726AD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.328 17.112L13.832 9.8H16.808L16.312 17.112H14.328ZM15.32 21.128C14.872 21.128 14.504 20.984 14.216 20.696C13.928 20.408 13.784 20.0667 13.784 19.672C13.784 19.2667 13.928 18.9307 14.216 18.664C14.504 18.3867 14.872 18.248 15.32 18.248C15.7787 18.248 16.1467 18.3867 16.424 18.664C16.712 18.9307 16.856 19.2667 16.856 19.672C16.856 20.0667 16.712 20.408 16.424 20.696C16.1467 20.984 15.7787 21.128 15.32 21.128Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualifyBadge);
export default __webpack_public_path__ + "static/media/qualify-badge.eeeb959bd6302a20de87504a96fd6e1b.svg";
export { ForwardRef as ReactComponent };